<template>
  <div class="tab-second">
    <div
      class="tab-btn-primary"
      :class="{'active': curItem === index}"
      v-for="(name, index) in names"
      :key="name"
      @click="selectItem(index)">
      {{ name }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'tab-second',
  props: {
    names: Array
  },
  data () {
    return {
      curItem: 0
    }
  },
  methods: {
    selectItem (name) {
      // 当前项避免点击加载
      if (name === this.curItem) {
        return
      }
      this.curItem = name
      this.$emit('handSelect', name)
    }
  }
}
</script>
<style lang="less" scoped>
.tab-second {
  display: flex;
  justify-content: center;
}
.tab-btn-primary {
  display: inline-block;
  width: 9em;
  margin-left: 10px;
  line-height: 3em;
  text-align: center;
  white-space: nowrap;
  color: #4A4A4A;
  border-radius: 5px;
  background-color: #ECECEC;
  cursor: pointer;
  &:first-child {
    margin-left: 0;
  }
}
.tab-btn-primary.active, .tab-btn-primary:hover {
  background: #3780FF;
  color: #fff;
}
</style>
